import { render, staticRenderFns } from "./Popper.vue?vue&type=template&id=18732603&scoped=true&"
import script from "./Popper.vue?vue&type=script&lang=ts&"
export * from "./Popper.vue?vue&type=script&lang=ts&"
import style0 from "./Popper.vue?vue&type=style&index=0&id=18732603&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18732603",
  null
  
)

export default component.exports